import {
  EXCHANGE_TO_CREATE_API_KEYS_PERMISSIONS,
  PRIMARY_EXCHANGE_TO_CREATE_API_KEYS_GUIDE,
} from "@shared/features/onboarding/constants";
import { AccountFormContext } from "@shared/features/common/AccountForm.context";
import { useContext } from "react";
import { ConfigurationExchangeInfo, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface UseSharedConnectExchangeExtraInfoProps {
  primaryExchange?: string;
  selectedSubExchange?: ConfigurationExchangeInfo;
}

const useSharedConnectExchangeExtraInfo = ({
  primaryExchange,
  selectedSubExchange,
}: UseSharedConnectExchangeExtraInfoProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const { selectedSubExchanges, isDemoWorkspace, exchangesData } =
    useContext(AccountFormContext)!;

  const getPermissions = () => {
    let permissionsStr = "";
    const subExchanges = selectedSubExchange
      ? [selectedSubExchange]
      : selectedSubExchanges;
    const permissionsArray = subExchanges
      ?.map((subExchange) =>
        t(EXCHANGE_TO_CREATE_API_KEYS_PERMISSIONS[subExchange.exchange])
      )
      .filter((permission) => !!permission?.length);

    const permissions = [...new Set(permissionsArray)];
    permissions.forEach((permission, index) => {
      const separator =
        index === 0 ? "" : index === permissions?.length - 1 ? " and " : ", ";
      permissionsStr = permissionsStr.concat(separator, permission);
    });
    return permissionsStr;
  };

  const createApiKeysGuideList = primaryExchange
    ? PRIMARY_EXCHANGE_TO_CREATE_API_KEYS_GUIDE[primaryExchange]?.map(
        (item) => {
          return t(item, { permissions: getPermissions() });
        }
      )
    : [];

  return {
    createApiKeysGuideList,
    isDemoWorkspace,
    exchangesData,
  };
};

export default useSharedConnectExchangeExtraInfo;
